import React, { useEffect, useState, useRef } from "react";
import ReactExport from "react-export-excel";
import { Button } from "antd";
import moment from 'moment';
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;



const Excelldownload = ({ data, from, loading }) => {
  // console.log(data);
  const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"];
  let fileName = 'স্টাফ হলিডে এলাউন্স প্রদানের তালিকা';

  if (loading) {
    return <Button type="ghost" style={{ width: "100%", marginRight: "10px" }}>....Loading</Button>
  } else
    return (
      <ExcelFile element={<Button type="primary" style={{ width: "100%", marginRight: "10px" }}>Download</Button>} filename={fileName}>
        <ExcelSheet data={data} name='স্টাফ হলিডে এলাউন্স প্রদানের তালিকা'>
          <ExcelColumn label="ডিপার্টমেন্ট" value="employeeDepartment" />
          <ExcelColumn label="পিন নং" value="employeeId" />
          <ExcelColumn label="নাম" value="employeeName" />
          <ExcelColumn label="পদবি" value="employeeRole" />

          <ExcelColumn label="এ্যালাউন্স/ কার্য" value="holidayAllowance" />
          <ExcelColumn label="কার্য দিবস " value="holidayattendance" />
        </ExcelSheet>
      </ExcelFile>
    );
};

export default Excelldownload;
